import axios from "axios"
import { FileAttachment, LocationAttachment, MediaAttachment, ReplyAttachment } from "../interfaces/Chat/MessageData"
import { chatMode } from "../functions/chat"
import { ReplyMessageChatGroup } from "../interfaces/Chat/Chat"

const API_URL = process.env.REACT_APP_API_URL

const CHAT = `${API_URL}chat`
const CHAT_GROUP = `${API_URL}chat-group`
const GET_TOTAL_CHAT = `${API_URL}chat/total-count`
const GET_V2_INIT_SYNC = `${API_URL}v2/chat/init`
const GET_INIT_GROUP_SYNC = `${API_URL}chat-group/init`
const SESSION_CHAT = `${API_URL}v2/chat/auth`
const SESSION_CHAT_V2 = `${API_URL}chat-agent/`

export const getInitSyncData = (limit: number, roomNumber: string, until: string, since: string, phone: string, tokenChat: string, mode: string, token: string) => {
    return axios.get(GET_V2_INIT_SYNC + `?limit=${limit}&mode=${mode}&as=${phone}${roomNumber ? `&roomNumber=${roomNumber}` : ''}${until ? `&until=${until}` : ''}${since ? `&since=${since}` : ''}`,
        {
            headers: {
                'X-Auth-token': token,
                'X-Chat-Auth-Token': tokenChat,
            }
        }
    )
}

export const getInitGroupSyncData = (limit: number, groupId: string, until: string, since: string, phone: string, tokenChat: string, mode: string, token: string) => {
    return axios.get(GET_INIT_GROUP_SYNC + `?limit=${limit}&mode=${mode}&as=${phone}${groupId ? `&groupId=${groupId}` : ''}${until ? `&until=${until}` : ''}${since ? `&since=${since}` : ''}`,
        {
            headers: {
                'X-Auth-token': token,
                'X-Chat-Auth-Token': tokenChat,
            }
        }
    )
}

export const postSendChat = (phone: string, as_phone: string, message: string, mode: string, token: string, tokenChat: string, attachment?: MediaAttachment | FileAttachment | LocationAttachment) => {
    return axios.post(`${CHAT}?mode=${mode}&as=${as_phone}`,
        attachment ?
            {
                phone: phone,
                message: message,
                attachment: attachment
            }
            :
            {
                phone: phone,
                message: message,
            },
        {
            headers: {
                'X-Auth-token': token,
                'X-Chat-Auth-Token': tokenChat,
            }
        }
    )
}

export const postSendChatGroup = (groupId: string, as_phone: string, message: string, mentions: string[], mode: string, token: string, tokenChat: string, attachment?: MediaAttachment | FileAttachment | LocationAttachment) => {
    return axios.post(`${CHAT_GROUP}/send?mode=${mode}&as=${as_phone}`,
        attachment ?
            {
                groupId,
                message,
                mentions,
                attachment
            }
            :
            {
                groupId,
                message,
                mentions,
            },
        {
            headers: {
                'X-Auth-token': token,
                'X-Chat-Auth-Token': tokenChat,
            }
        }
    )
}

export const postReplyChat = (messageId: string, phone_receiver: string, as_phone: string, is_sender_chat: boolean, reply_message: string, mode: string, token: string, tokenChat: string, attachment?: ReplyAttachment) => {
    return axios.post(`${CHAT}/${messageId}/reply?mode=${mode}&as=${as_phone}`,
        attachment ?
            {
                phone_receiver: phone_receiver,
                is_sender_chat: is_sender_chat,
                reply_message: reply_message,
                attachment: attachment
            }
            :
            {
                phone_receiver: phone_receiver,
                is_sender_chat: is_sender_chat,
                reply_message: reply_message
            },
        {
            headers: {
                'X-Auth-token': token,
                'X-Chat-Auth-Token': tokenChat,
            }
        }
    )
}

export const postReplyChatGroup = (groupId: string, repliedMessageId: string, message: ReplyMessageChatGroup, as_phone: string, mode: string, token: string, tokenChat: string) => {
    return axios.post(`${CHAT_GROUP}/reply?mode=${mode}&as=${as_phone}`,
        {
            groupId,
            repliedMessageId,
            message,
        },
        {
            headers: {
                'X-Auth-token': token,
                'X-Chat-Auth-Token': tokenChat,
            }
        }
    )
}

export const postForwardChat = (targets: string[], messagesId: string[], as_phone: string, mode: string, token: string, tokenChat: string) => {
    return axios.post(`${CHAT}/forward?mode=${mode}&as=${as_phone}`,
        {
            targets,
            messagesId
        },
        {
            headers: {
                'X-Auth-token': token,
                'X-Chat-Auth-Token': tokenChat,
            }
        }
    )
}

export const postForwardGroupChat = (to: string[], messagesId: string[], as_phone: string, mode: string, token: string, tokenChat: string) => {
    return axios.post(`${CHAT_GROUP}/forward?mode=${mode}&as=${as_phone}`,
        {
            to,
            messagesId
        },
        {
            headers: {
                'X-Auth-token': token,
                'X-Chat-Auth-Token': tokenChat,
            }
        }
    )
}

export const putEditChat = (messageId: string, phone_receiver: string, as_phone: string, new_message: string, mode: string, token: string, tokenChat: string) => {
    return axios.put(`${CHAT}/${messageId}?mode=${mode}&as=${as_phone}`,
        {
            phone_receiver: phone_receiver,
            new_message: new_message,
        },
        {
            headers: {
                'X-Auth-token': token,
                'X-Chat-Auth-Token': tokenChat,
            }
        }
    )
}

export const putEditChatGroup = (messageId: string, groupId: string, as_phone: string, newMessage: string, mentions: string[], mode: string, token: string, tokenChat: string) => {
    return axios.post(`${CHAT_GROUP}/edit?mode=${mode}&as=${as_phone}`,
        {
            messageId,
            groupId,
            newMessage,
            mentions
        },
        {
            headers: {
                'X-Auth-token': token,
                'X-Chat-Auth-Token': tokenChat,
            }
        }
    )
}

export const deleteUnsendChat = (messageId: string, phone_receiver: string, as_phone: string, mode: string, token: string, tokenChat: string) => {
    return axios.delete(`${CHAT}/${messageId}?mode=${mode}&as=${as_phone}`, {
        data: {
            phone_receiver: phone_receiver
        },
        headers: {
            'X-Auth-token': token,
            'X-Chat-Auth-Token': tokenChat,
        }
    });
};

export const deleteUnsendChatGroup = (groupId: string, messageId: string, as_phone: string, mode: string, token: string, tokenChat: string) => {
    return axios.post(`${CHAT_GROUP}/unsend?mode=${mode}&as=${as_phone}`,
        {
            groupId,
            messageId
        },
        {
            headers: {
                'X-Auth-token': token,
                'X-Chat-Auth-Token': tokenChat,
            }
        }
    );
};

export const createSessionChat = (phones: string[], token: string) => {
    return axios.post(SESSION_CHAT,
        {
            phones
        },
        {
            headers: {
                'X-Auth-token': token
            }
        }
    );
};

export const createSessionChatV2 = (phones: string[], token: string) => {
    return axios.post(SESSION_CHAT_V2 + 'tokens',
        {
            phones
        },
        {
            headers: {
                'X-Auth-token': token
            }
        }
    );
};

export const deleteSessionChat = (as_phone: string, mode: string, token: string, tokenChat: string) => {
    let url = ''
    if (mode === 'chat-agent') url = `${SESSION_CHAT_V2}tokens?mode=${mode}`
    else url = `${SESSION_CHAT}?mode=${mode}&as=${as_phone}`

    return axios.delete(url,
        {
            headers: {
                'X-Auth-token': token,
                'X-Chat-Auth-Token': tokenChat,
            }
        }
    );
};

export const takeSessionChat = (customerPhone: string, initiatedByAgent: boolean, phoneId: string, token: string) => {
    return axios.post(SESSION_CHAT_V2 + 'agent/sessions/create',
        {
            customerPhone,
            initiatedByAgent,
            phoneId
        },
        {
            headers: {
                'X-Auth-token': token
            }
        }
    );
};

export const endSessionChat = (sessionId: string, note: string, token: string) => {
    return axios.post(SESSION_CHAT_V2 + 'agent/sessions/end',
        {
            sessionId,
            note
        },
        {
            headers: {
                'X-Auth-token': token
            }
        }
    );
};

export const switchSessionChat = (sessionId: string, agentId: string, token: string) => {
    return axios.post(SESSION_CHAT_V2 + 'agent/sessions/' + sessionId + '/switch',
        {
            agentId,
        },
        {
            headers: {
                'X-Auth-token': token
            }
        }
    );
};

export const putSettingChat = (sessionsTimeoutInSeconds: number, allowAgentPreemptiveStartSessions: boolean, captionWhenSessionEnded: string, token: string) => {
    return axios.put(SESSION_CHAT_V2 + 'admin/config',
        {
            sessionsTimeoutInSeconds,
            allowAgentPreemptiveStartSessions,
            captionWhenSessionEnded,
        },
        {
            headers: {
                'X-Auth-token': token
            },
        }
    )
}